import React from "react";

import { Box, Botao, Alerta, TipoAlerta, Form, CampoTexto, TipoBotao, Combo } from "@intechprev/componentes-web";
import { WebRecadParticipanteDadosEntidade, UFEntidade } from "../../entidades";
import { ArquivoUpload, ArquivoUploadItem } from "./ArquivoUpload";
import { Passos } from ".";
import { RecadastramentoService } from "../../services";

interface Props {
  setDadosPasso: any;
  Dados: any;
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  HouveAlteracao: any;
  ListaArquivo: Array<ArquivoUploadItem>;
  setListaArquivo: any;
  Avancar: () => void;
  Voltar: () => void;
  NumeroPassoAtual: number;
}

interface State {
  Nome: string;
  DataEmissao: string;
  OrgaoEmissor: string;
  Naturalidade: string;
  UfNaturalidade: string;
  ListaUF: Array<UFEntidade>;
}

export class Passo2 extends React.Component<Props, State> {
  private form = React.createRef<Form>();
  private alerta = React.createRef<Alerta>();
  private arquivo = React.createRef<ArquivoUpload>();

  constructor(props: Props) {
    super(props);

    this.state = {
      Nome: "",
      DataEmissao: "",
      OrgaoEmissor: "",
      Naturalidade: "",
      UfNaturalidade: "",
      ListaUF: [],
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      const ListaUF = await RecadastramentoService.BuscarListaUF();

      this.setState({
        Nome: this.props.Dados.Nome || this.props.DadosOriginais.NOME_ENTID || "",
        DataEmissao: this.props.Dados.DataEmissao || this.props.DadosOriginais.DT_EMIS_IDENT || "",
        OrgaoEmissor: this.props.Dados.OrgaoEmissor || this.props.DadosOriginais.ORG_EMIS_IDENT || "",
        Naturalidade: this.props.Dados.Naturalidade || this.props.DadosOriginais.NATURALIDADE || "",
        UfNaturalidade: this.props.Dados.UfNaturalidade || this.props.DadosOriginais.UF_NATURALIDADE || "",
        ListaUF,
      });
    } catch (err) {
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  CompararDados = () => {
    return (
      this.props.HouveAlteracao(this.props.DadosOriginais.NOME_ENTID, this.state.Nome) ||
      this.props.HouveAlteracao(this.props.DadosOriginais.DT_EMIS_IDENT, this.state.DataEmissao) ||
      this.props.HouveAlteracao(this.props.DadosOriginais.ORG_EMIS_IDENT, this.state.OrgaoEmissor) ||
      this.props.HouveAlteracao(this.props.DadosOriginais.NATURALIDADE, this.state.Naturalidade) ||
      this.props.HouveAlteracao(this.props.DadosOriginais.UF_NATURALIDADE, this.state.UfNaturalidade)
    );
  };

  SalvarDados = () => {
    const d = {
      Nome: this.state.Nome,
      DataEmissao: this.state.DataEmissao,
      OrgaoEmissor: this.state.OrgaoEmissor,
      Naturalidade: this.state.Naturalidade,
      UfNaturalidade: this.state.UfNaturalidade,
    };
    this.props.setDadosPasso(Passos.Passo2, d);
  };

  Voltar = () => {
    this.SalvarDados();
    this.props.Voltar();
  };

  Proximo = async () => {
    try {
      await this.alerta.current.limparErros();
      await this.form.current.validar();
      this.arquivo.current.MostrarAviso(false);

      if (this.form.current.isValido()) {
        await RecadastramentoService.ValidarDataEmissao(this.state.DataEmissao.replace(/\//gm, "."));

        if (this.PrecisaEnvarArquivo()) {
          await this.alerta.current.adicionarErro("O envio de pelo menos um documento é obrigatório.");
          this.arquivo.current.MostrarAviso(true);
        } else {
          this.SalvarDados();

          this.props.Avancar();
        }
      }
    } catch (err) {
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  PrecisaEnvarArquivo = () => {
    const ListaArquivoPasso = this.props.ListaArquivo.filter((arquivo) => arquivo.Passo === Passos.Passo2);

    return this.CompararDados() && ListaArquivoPasso.length === 0;
  };

  // CorrigirData = (data: string) => {
  //   const us = moment(data, "MM/DD/YYYY");

  //   const br = moment(data, "DD/MM/YYYY");

  //   if (us.isValid()) return us.format("DD/MM/YYYY");

  //   if (br.isValid()) return br.format("DD/MM/YYYY");

  //   return "";
  // };

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Identificação`}>
        <Form ref={this.form}>
          <CampoTexto contexto={this} nome={"Nome"} titulo={"Nome"} obrigatorio valor={this.state.Nome} tamanhoTitulo={"lg-3"} max={60} />

          <CampoTexto
            valor={(this.props.DadosOriginais.DT_NASCIMENTO || "")}
            titulo={"Data de Nascimento"}
            contexto={this}
            desabilitado
            nome={"DT_NASCIMENTO"}
            tamanhoTitulo={"lg-3"}
          />

          <CampoTexto
            valor={this.props.DadosOriginais.CPF_CGC || ""}
            titulo={"CPF"}
            contexto={this}
            desabilitado
            nome={"CPF_CGC"}
            tamanhoTitulo={"lg-3"}
          />

          <CampoTexto
            valor={this.props.DadosOriginais.NU_IDENT || ""}
            titulo={"RG"}
            contexto={this}
            desabilitado
            nome={"NU_IDENT"}
            tamanhoTitulo={"lg-3"}
          />

          <CampoTexto
            contexto={this}
            nome={"DataEmissao"}
            titulo={"Data de Emissão"}
            obrigatorio
            valor={this.state.DataEmissao}
            tamanhoTitulo={"lg-3"}
          />

          <CampoTexto
            contexto={this}
            nome={"OrgaoEmissor"}
            titulo={"Órgão Emissor"}
            obrigatorio
            valor={this.state.OrgaoEmissor}
            tamanhoTitulo={"lg-3"}
            max={8}
          />

          <CampoTexto valor={this.state.Naturalidade} titulo={"Naturalidade"} contexto={this} nome={"Naturalidade"} tamanhoTitulo={"lg-3"} max={25} />

          <Combo
            valor={this.state.UfNaturalidade}
            titulo={"Naturalidade - Estado"}
            obrigatorio
            contexto={this}
            nome={"UfNaturalidade"}
            opcoes={this.state.ListaUF}
            nomeMembro={"DS_UNID_FED"}
            valorMembro={"CD_UNID_FED"}
            textoVazio={"Escolha o seu Estado"}
            tamanhoTitulo={"3"}
          />

          <CampoTexto
            valor={this.props.DadosOriginais.NOME_MAE || ""}
            titulo={"Nome da Mãe"}
            contexto={this}
            desabilitado
            nome={"NOME_MAE"}
            tamanhoTitulo={"lg-3"}
          />

          <CampoTexto
            valor={this.props.DadosOriginais.NOME_PAI || ""}
            titulo={"Nome da Pai"}
            contexto={this}
            desabilitado
            nome={"NOME_PAI"}
            tamanhoTitulo={"lg-3"}
          />

          <Alerta tipo={TipoAlerta.danger} ref={this.alerta} padraoFormulario />

          <ArquivoUpload
            ListaArquivo={this.props.ListaArquivo}
            PassoAtual={Passos.Passo2}
            setListaArquivo={this.props.setListaArquivo}
            texto={"Em caso de alteração de qualquer dado, por favor, anexar cópia do novo RG."}
            ref={this.arquivo}
          />

          <Botao onClick={this.Voltar} titulo={"Voltar"} className={"m-2"} tipo={TipoBotao.light} icone={"angle-double-left"} iconeDireita />

          <Botao onClick={this.Proximo} titulo={"Continuar"} icone={"angle-double-right"} iconeDireita />
        </Form>
      </Box>
    );
  }
}
